import { memo, useState } from 'react';
import './style.scss';
import { Divider, Row, Select, Popconfirm, Tag, Empty, Radio, Button, message, Col } from 'antd';
import stl from 'string-to-color';
import useLogout from '../../hooks/useLogout';
import { useGetCompanyListMinimal } from '../../hooks/useCompanies';
import { useGetAllBoxesOfOrder, useGetOrderListMinimal, useProcessInboundDraft } from '../../hooks/useOrders';

const MappingBox = ({ selectedPii, setSelectedPii, refetchPiiDrafts }) => {
    const [selectedCompanies, setSelectedCompanies] = useState('');
    const [selectedOrders, setSelectedOrders] = useState('');
    const [boxesList, setBoxesList] = useState([]);
    const [selectedBox, setSelectedBox] = useState(null);
    const [confirmingSubmit, setConfirmingSubmit] = useState(false);
    const [isSubmittingDraft, setSubmittingInboundDraft] = useState(false);
    const logout = useLogout();

    const { data: companies, isFetching: isFetchingcompanies, isFetched: isFetchedcompanies, refetch: refetchcompanies } = useGetCompanyListMinimal();
    const {
        data: ordersList,
        isFetching: isFetchingOrders,
        isFetched: isFetchedOrders,
        refetch: refetchOrders,
    } = useGetOrderListMinimal(selectedCompanies);

    const onSuccessBoxesFetch = data => {
        if (data?.data?.boxInfo && data?.data?.boxInfo?.length > 0) {
            setBoxesList(data?.data?.boxInfo);
        } else {
            setBoxesList([]);
        }
    };

    const onErrorBoxesFetch = err => {
        message.error(err?.response?.data?.message || 'Error');
        if (err?.response?.status === 401) logout();
    };

    const {
        data: orderBoxDetails,
        refetch,
        isFetching: isFetchingBoxes,
        isFetched: isFetchedBoxes,
    } = useGetAllBoxesOfOrder(selectedOrders, onSuccessBoxesFetch, onErrorBoxesFetch);

    const resetAll = fullReset => {
        setSelectedCompanies('');
        setSelectedOrders('');
        setBoxesList([]);
        setSelectedBox(null);
        setConfirmingSubmit(false);
        setSubmittingInboundDraft(false);
        if (fullReset) {
            refetchPiiDrafts();
            setSelectedPii(null);
        }
    };

    const onSuccessProcessInboundDraft = data => {
        message.success('Successfully Submitted!');
        resetAll(true);
    };

    const onErrorProcessInboundDraft = err => {
        // pending
        message.error(err?.response?.data?.message || 'Error');
        if (err?.response?.status === 401) logout();
    };

    const { mutate: SubmitTheDraftMappingToBox } = useProcessInboundDraft(onSuccessProcessInboundDraft, onErrorProcessInboundDraft);

    const getCompanies = () => {
        return (
            companies?.map(company => {
                return {
                    label: (
                        <Row>
                            <Col
                                flex="60px"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Tag color={stl(company?.code)}>{company?.code}</Tag>
                            </Col>
                            <Col flex="auto" style={{}}>
                                {company?.name}
                            </Col>
                        </Row>
                    ),
                    searchBy: `${company?.code} ${company?.name}`,
                    value: company?.code,
                };
            }) || []
        );
    };

    const getOrders = () => {
        return (
            ordersList?.map(order => {
                return {
                    label: (
                        <>
                            <Row>
                                <Col
                                    flex="60px"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Tag color={stl(order?.companyCode)}>{order?.companyCode}</Tag>
                                </Col>
                                <Col flex="auto" style={{}}>
                                    {order?.name}
                                </Col>
                            </Row>
                        </>
                    ),
                    searchBy: `[${order?.companyCode}] : ${order?.name}`,
                    value: order?._id,
                };
            }) || []
        );
    };

    const getHeaders = () => {
        return (
            <div className="d-flex pii-header">
                <div className="select-div">
                    <h5>Client: </h5>
                    <div>
                        <Select
                            loading={isFetchingcompanies}
                            mode="single"
                            style={{
                                minWidth: 300,
                            }}
                            allowClear
                            className="company-select"
                            placeholder={'Select Company'}
                            value={selectedCompanies}
                            dropdownMatchSelectWidth={false}
                            dropdownStyle={{ minWidth: '330px' }}
                            size="small"
                            options={getCompanies()}
                            optionFilterProp="searchBy"
                            listItemHeight={10}
                            listHeight={550}
                            maxTagCount={1}
                            maxTagTextLength={10}
                            onChange={value => {
                                setSelectedCompanies(value);
                                setSelectedOrders('');
                                setBoxesList([]);
                                setSelectedBox(null);
                            }}
                            onClear={() => {
                                setSelectedCompanies('');
                                setSelectedOrders('');
                                setBoxesList([]);
                                setSelectedBox(null);
                            }}
                            showSearch
                            // value={selectedData}
                        />
                    </div>
                </div>
                <div className="select-div">
                    <h5>Order: </h5>
                    <div>
                        <Select
                            loading={isFetchingcompanies}
                            mode="single"
                            allowClear
                            className={'order-select'}
                            placeholder={'Select Order'}
                            dropdownMatchSelectWidth={false}
                            dropdownStyle={{ minWidth: '350px' }}
                            style={{
                                minWidth: 350,
                            }}
                            size="small"
                            options={getOrders()}
                            value={selectedOrders}
                            optionFilterProp="searchBy"
                            listItemHeight={10}
                            listHeight={550}
                            maxTagCount={1}
                            maxTagTextLength={10}
                            onChange={value => {
                                setSelectedOrders(value);
                                setBoxesList([]);
                                setSelectedBox(null);
                            }}
                            onClear={() => {
                                setSelectedOrders('');
                                setBoxesList([]);
                                setSelectedBox(null);
                            }}
                            showSearch
                            disabled={!selectedCompanies}
                        />{' '}
                    </div>
                </div>
            </div>
        );
    };

    const handleBoxClick = (e, box) => {
        e.preventDefault();
        e.stopPropagation();
        if (selectedBox?._id === box?._id) {
            setSelectedBox(null);
        } else {
            setSelectedBox(box);
        }
    };

    const handleSubmit = () => {
        let payload = {
            orderId: selectedOrders,
            boxId: selectedBox?._id,
            inboundDraftId: selectedPii?._id,
        };

        setConfirmingSubmit(false);
        setSubmittingInboundDraft(true);
        SubmitTheDraftMappingToBox(payload);
    };

    const getBox = box => {
        return (
            <div className={`singleBox ${selectedBox?._id === box?._id ? 'selected-box' : ''}`}>
                <div className="box-details-div">
                    <span className="text-title">
                        <Radio checked={selectedBox?._id === box?._id} onClick={e => handleBoxClick(e, box)} />
                    </span>
                </div>
                <div className="box-details-div">
                    <span className="text-title">Tracking Number: </span>
                    <span className="text-value"> {box?.trackingNumber}</span>
                </div>
                <div className="box-details-div">
                    <span className="text-title">Reference Number: </span>
                    <span className="text-value"> {box?.referenceNumber}</span>
                </div>
                {box?.src && (
                    <div className="box-details-div">
                        <span className="text-title">From Address: </span>
                        <span className="text-value">
                            {' '}
                            {`${box?.src?.addressLine1}, ${box?.src?.addressLine2}, ${box?.src?.city}, ${box?.src?.stateOrProvince}, ${box?.src?.country}`}
                        </span>
                    </div>
                )}
            </div>
        );
    };

    const getBoxSection = () => {
        if (selectedOrders && boxesList?.length > 0) {
            return (
                <Row gutter={[4, 4]} className="boxes-list">
                    {[...boxesList]?.map(box => getBox(box))}
                </Row>
            );
        } else if (selectedOrders && boxesList?.length === 0) {
            return <Empty className="empty-items" />;
        } else {
            return (
                <div className="empty-items">
                    <span style={{ fontSize: '13px' }}>Please select order for Boxes</span>
                </div>
            );
        }
    };

    const getMiddleSection = () => {
        return (
            <div className="middle-section px-1 py-1">
                <div className="box-section">
                    <h5>Boxes</h5>
                    {getBoxSection()}
                </div>
            </div>
        );
    };

    const getUpdateButtonSection = () => {
        return (
            <div className="update_button_section">
                <Button
                    size="small"
                    onClick={() => {
                        resetAll();
                    }}
                    loading={isSubmittingDraft}
                >
                    Reset
                </Button>
                <Popconfirm
                    title="Assign Box To Draft PII"
                    description="Are you sure to Assign box to the Draft PII?"
                    onConfirm={handleSubmit}
                    onCancel={() => {
                        setConfirmingSubmit(false);
                    }}
                    okText="Yes"
                    cancelText="No"
                    open={confirmingSubmit}
                >
                    <Button
                        size="small"
                        onClick={() => {
                            setConfirmingSubmit(true);
                        }}
                        type="primary"
                        disabled={!selectedPii || !selectedBox || !selectedOrders}
                        loading={isSubmittingDraft}
                    >
                        Save
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    return (
        <div className="modal-box-pii-mapping">
            {getHeaders()}
            <Divider style={{ margin: '5px 0', padding: 0 }} />
            {getMiddleSection()}
            {getUpdateButtonSection()}
        </div>
    );
};

export default memo(MappingBox);
